export class SaveContactCompanyInfo {
    id: number;
    contactId: number;
    companyId: number;
    isActive: boolean;
    title: string;
    constructor(id: number, contactId: number, companyId: number, isActive: boolean, title: string) {
        this.id = id;
        this.contactId = contactId;
        this.companyId = companyId;
        this.isActive = isActive;
        this.title = title;
    }
}


// WEBPACK FOOTER //
// ./src/app/core/components/contacts/contact-nav/contact-info-category-lists/models/save-contact-company-info .ts